<script setup>
const { Settings } = useSettings()
const config = useRuntimeConfig()

const { data: Sources  = [] } = await useFetch('/api/source')
</script>
<template>
  <section id="blob_page_about">

    <span class='blob_about' v-html='Settings.about'></span>
    <template v-if='Settings.showSourcesInAbout'>
      <h2 class='mt-6'>{{$t('Sources')}}</h2>
      <v-list lines='two' class="blob_source_list">
        <v-list-item v-for="source in Sources" :to="`/s/${source.id}`">
          <v-list-item-title>
            <v-chip size='small' color="red" label><v-icon>mdi-rss</v-icon>{{source.type}}</v-chip>  <v-chip color='primary' size="small" label>{{ source._count.posts }} posts</v-chip><br/>
            {{ source.name }} - {{ source.link }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{source.description }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <v-btn class='my-5' color="info" variant='tonal' target='_blank' href='https://blob.news' prepend-icon="mdi-information">Blob v{{ config.public.version }}</v-btn>
    </template>
  </section>
</template>